import React, { useState, useEffect } from 'react';

import Dashboard from '../program/Dashboard';

export default function Account() {
    return (
		<Dashboard />
	)
}
